module.exports = __webpack_public_path__ + "img/footer_followme.83420d7a.png";